import { m } from "../../paraglide/messages.js";
import { vars } from "../css-vars";
import { mapExtent, type RingId, rings } from "../suite-map";

const ringName: Record<RingId, () => string> = {
  core: m.ring_core,
  tomorrow: m.ring_tomorrow,
  partners: m.ring_partners,
  customers: m.ring_customers,
  world: m.ring_world,
};

export const mapViewBox = `${-mapExtent} ${-mapExtent} ${mapExtent * 2} ${mapExtent * 2}`;

/** The rings from the inside out, each with its name at the bottom: the hero's and the map's. */
export function MapRings({ withCore }: { withCore: boolean }) {
  return (
    <g>
      {rings
        .filter((ring) => withCore || ring.id !== "core")
        .map((ring, i) => (
          <g key={ring.id} className="map-ring" style={vars({ "--i": i })}>
            <circle r={ring.radius} />
            {ring.id !== "core" && (
              <text y={ring.radius - 14} textAnchor="middle">
                {ringName[ring.id]().toUpperCase()}
              </text>
            )}
          </g>
        ))}
    </g>
  );
}
